import service from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const getYardsService = () => {
    return service.get(`/driver-yards`, { params: getModelTypeIDAndEntityID() });
};
